import { Injectable } from '@angular/core';
import _ from 'lodash';
import { NgxSpinnerService } from "ngx-spinner";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  loading: boolean = false;
  public isTrial = new BehaviorSubject(null);
  constructor(private spinner: NgxSpinnerService) { }

  setLoading(loading) {
    if (loading) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }

  setIsTrial(newValue) {
    this.isTrial.next(newValue);
  }

}
